import { NumberInput, Slider } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './LocativeShareInput.module.scss';
import { Props } from './LocativeShareInput.types';

const LocativeShareInput = ({ value, onChange, totalAmount, defaultValue }: Props) => {
  const { t } = useTranslation();

  const share = value ?? 0;
  const locativeAmount = ((totalAmount ?? 0) * share) / 100;
  const personalAmount = (totalAmount ?? 0) - locativeAmount;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.label}>
          {t('expense.form.locativeShare.label', 'Part locative')}
        </span>
        {defaultValue !== undefined && value === defaultValue && (
          <span className={styles.prefilledBadge}>
            {t('expense.form.locativeShare.prefilled', 'Pré-rempli à {{ percent }}%', {
              percent: defaultValue,
            })}
          </span>
        )}
      </div>
      <div className={styles.inputRow}>
        <Slider
          className={styles.slider}
          min={0}
          max={100}
          step={1}
          value={share}
          onChange={onChange}
          label={percent => `${percent}%`}
        />
        <NumberInput
          className={styles.numberInput}
          min={0}
          max={100}
          suffix="%"
          value={share}
          onChange={val => onChange(typeof val === 'number' ? val : undefined)}
        />
      </div>
      <div className={styles.breakdown}>
        <span>
          {t(
            'expense.form.locativeShare.locativeAmount',
            'Part locative imputable : {{ amount }} €',
            {
              amount: locativeAmount.toFixed(2),
            }
          )}
        </span>
        <span>
          {t('expense.form.locativeShare.personalAmount', 'Reste personnel : {{ amount }} €', {
            amount: personalAmount.toFixed(2),
          })}
        </span>
      </div>
    </div>
  );
};

export default LocativeShareInput;
